import React from "react";
import { FaClock, FaMapMarkerAlt } from "react-icons/fa";
import contentConfig from "../content.config.json";
import "../Styles/Footer.css";

const Footer = () => {
  const { name, address, hours } = contentConfig.footer;

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <div className="footer-header">
            <FaClock className="footer-icon" />
            <h3>Business Hours</h3>
          </div>
          <div className="hours-grid">
            {hours.map((hour, index) => (
              <div
                key={index}
                className={`hour-item ${hour.closed ? "hour-item--closed" : ""}`}
              >
                <span className="hour-day">{hour.day}</span>
                <span className="hour-time">{hour.time}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="footer-section">
          <div className="footer-header">
            <FaMapMarkerAlt className="footer-icon" />
            <h3>Location</h3>
          </div>
          <p className="footer-address">{address}</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} {name}. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;